import { Status } from "components";
import FormattedAddress from "components/Atoms/FormattedAddress";
import { PhosphorGlobe, PhosphorPhone, PhosphorWarningInline } from "components/Atoms/PhosphorIcon";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import Tag from "components/Tag/Tag";
import TagList from "components/Tag/TagList";
import WebsiteLink from "components/Website/WebsiteLink";
import React from "react";
import { nounToLower } from "utilities/translationUtils";

const CompanyStatusAndProfile = ({ item, displayStatus }: { item: server.dto.CompanyForList, displayStatus: boolean }) => {
  const anyProfileTags = item.isArtist !== "no" || item.isVenue !== "no" || item.isPromoter !== "no";

  return <div className="flex-column gap-small">
    {displayStatus && <div><Status status={item.status} small /></div>}
    {item.contactCount !== 0 ? `${item.contactCount} ${nounToLower(RESX.Contact.Contacts)}` : null}
    {anyProfileTags && <div className="tag-list">
      {item.isArtist === "active" && <Tag color="green-basic" label={RESX.Artist.resxArtist} title={RESX.Artist.resxArtist} />}
      {item.isArtist === "noLongerActive" && <Tag color="green-basic-disabled" label={RESX.Artist.resxArtist} title={RESX.Artist.resxArtist} />}
      {item.isVenue === "active" && <Tag color="blue-basic" label={RESX.Venue.resxVenue} title={RESX.Venue.resxVenue} />}
      {item.isPromoter === "active" && <Tag color="purple-basic" label={RESX.Promoter.resxPromoter} title={RESX.Promoter.resxPromoter} />}
    </div>}
  </div>;
};

const ContactDetailsElement = ({ item }: { item: server.dto.CompanyForList }) => {
  return <div className="flex-column gap-small">
    {(item.primaryLandline) && <div className="flex gap">
      <div><PhosphorPhone iconColor="gray" /></div>
      <div>{item.primaryLandline}</div>
    </div>}

    {(item.website) && <div className="flex gap">
      <div><PhosphorGlobe iconColor="gray" /></div>
      <div>
        <WebsiteLink website={item.website} />
      </div>
    </div>}
  </div>;
};

export const cardLayout = (viewModel: server.viewmodel.CompanyListFrontModel): ListTemplateLayout<server.dto.CompanyForList> => ({
  type: "card",
  sections: {
    renderTitle: item => <CompanySidePanel type="company" companyId={item.companyId} trigger={<LargeClickableTitle
      icon={!item.isValidated ? <PhosphorWarningInline /> : undefined}
      title={item.name}
    />} />,
    hideTitle: () => false,
    renderBody: item => <>
      <CompanyStatusAndProfile item={item} displayStatus={viewModel.statuses.length > 1} />
      <div>
        <FormattedAddress address={item.address} />
      </div>
      <ContactDetailsElement item={item} />
    </>,
    renderFooter: item => <TagList tags={item.tags} length="short" />,
    hideFooter: item => item.tags.length === 0
  }
});